import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ICmsBlock } from '@icms/core/resource/block/icms-block';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NBasketViewCms } from './basket-view-cms.component';

@Injectable({ providedIn: 'root' })
export class BasketViewCmsResolver implements Resolve<void | ICmsBlock<NBasketViewCms.IBlockData>> {
    constructor(private iCmsBlockResource: ICmsBlockResource) {}
    resolve(): Promise<any> {
        return this.iCmsBlockResource.retrieve({ bareUrl: NBasketViewCms.BLOCK_ID, createOnError: true }, undefined);
    }
}
